import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import axios from "axios";
import Navbar from "../components/Navbar";

const API_URL = process.env.REACT_APP_BACKEND_URL;

const WILAYA_LABELS = {
  "adrar": { label: "Adrar", code: "01" },
  "chlef": { label: "Chlef", code: "02" },
  "laghouat": { label: "Laghouat", code: "03" },
  "oum-el-bouaghi": { label: "Oum El Bouaghi", code: "04" },
  "batna": { label: "Batna", code: "05" },
  "bejaia": { label: "Béjaïa", code: "06" },
  "biskra": { label: "Biskra", code: "07" },
  "bechar": { label: "Béchar", code: "08" },
  "blida": { label: "Blida", code: "09" },
  "bouira": { label: "Bouira", code: "10" },
  "tamanrasset": { label: "Tamanrasset", code: "11" },
  "tebessa": { label: "Tébessa", code: "12" },
  "tlemcen": { label: "Tlemcen", code: "13" },
  "tiaret": { label: "Tiaret", code: "14" },
  "tizi-ouzou": { label: "Tizi Ouzou", code: "15" },
  "alger": { label: "Alger", code: "16" },
  "djelfa": { label: "Djelfa", code: "17" },
  "jijel": { label: "Jijel", code: "18" },
  "setif": { label: "Sétif", code: "19" },
  "saida": { label: "Saïda", code: "20" },
  "skikda": { label: "Skikda", code: "21" },
  "sidi-bel-abbes": { label: "Sidi Bel Abbès", code: "22" },
  "annaba": { label: "Annaba", code: "23" },
  "guelma": { label: "Guelma", code: "24" },
  "constantine": { label: "Constantine", code: "25" },
  "medea": { label: "Médéa", code: "26" },
  "mostaganem": { label: "Mostaganem", code: "27" },
  "msila": { label: "M'Sila", code: "28" },
  "mascara": { label: "Mascara", code: "29" },
  "ouargla": { label: "Ouargla", code: "30" },
  "oran": { label: "Oran", code: "31" },
  "el-bayadh": { label: "El Bayadh", code: "32" },
  "illizi": { label: "Illizi", code: "33" },
  "bordj-bou-arreridj": { label: "Bordj Bou Arréridj", code: "34" },
  "boumerdes": { label: "Boumerdès", code: "35" },
  "el-tarf": { label: "El Tarf", code: "36" },
  "tindouf": { label: "Tindouf", code: "37" },
  "tissemsilt": { label: "Tissemsilt", code: "38" },
  "el-oued": { label: "El Oued", code: "39" },
  "khenchela": { label: "Khenchela", code: "40" },
  "souk-ahras": { label: "Souk Ahras", code: "41" },
  "tipaza": { label: "Tipaza", code: "42" },
  "mila": { label: "Mila", code: "43" },
  "ain-defla": { label: "Aïn Defla", code: "44" },
  "naama": { label: "Naâma", code: "45" },
  "ain-temouchent": { label: "Aïn Témouchent", code: "46" },
  "ghardaia": { label: "Ghardaïa", code: "47" },
  "relizane": { label: "Relizane", code: "48" },
  "timimoun": { label: "Timimoun", code: "49" },
  "bordj-badji-mokhtar": { label: "Bordj Badji Mokhtar", code: "50" },
  "ouled-djellal": { label: "Ouled Djellal", code: "51" },
  "beni-abbes": { label: "Béni Abbès", code: "52" },
  "in-salah": { label: "In Salah", code: "53" },
  "in-guezzam": { label: "In Guezzam", code: "54" },
  "touggourt": { label: "Touggourt", code: "55" },
  "djanet": { label: "Djanet", code: "56" },
  "el-mghaier": { label: "El M'Ghaier", code: "57" },
  "el-meniaa": { label: "El Menia", code: "58" },
  "aflou": { label: "Aflou", code: "59" },
  "barika": { label: "Barika", code: "60" },
  "ksar-chellala": { label: "Ksar Chellala", code: "61" },
  "messaad": { label: "Messaad", code: "62" },
  "ain-oussera": { label: "Aïn Oussera", code: "63" },
  "boussaada": { label: "Boussaâda", code: "64" },
  "el-abiodh-sidi-cheikh": { label: "El Abiodh Sidi Cheikh", code: "65" },
  "el-kantara": { label: "El Kantara", code: "66" },
  "bir-el-ater": { label: "Bir El Ater", code: "67" },
  "ksar-el-boukhari": { label: "Ksar El Boukhari", code: "68" },
  "el-aricha": { label: "El Aricha", code: "69" },
};

const SPECIALTY_LABELS = {
  "generaliste": { label: "Médecin généraliste", api: "general" },
  "cardiologue": { label: "Cardiologue", api: "cardiology" },
  "dermatologue": { label: "Dermatologue", api: "dermatology" },
  "gynecologue": { label: "Gynécologue", api: "gynecology" },
  "ophtalmologue": { label: "Ophtalmologue", api: "ophthalmology" },
  "pediatre": { label: "Pédiatre", api: "pediatrics" },
  "dentiste": { label: "Dentiste", api: "dentistry" },
  "orthopediste": { label: "Orthopédiste", api: "orthopedics" },
  "psychiatre": { label: "Psychiatre", api: "psychiatry" },
  "neurologue": { label: "Neurologue", api: "neurology" },
  "urologue": { label: "Urologue", api: "urology" },
  "orl": { label: "ORL", api: "ent" },
  "radiologue": { label: "Radiologue", api: "radiology" },
  "gastro-enterologue": { label: "Gastro-entérologue", api: "gastroenterology" },
  "pneumologue": { label: "Pneumologue", api: "pneumology" },
  "chirurgien": { label: "Chirurgien général", api: "general_surgery" },
  "endocrinologue": { label: "Endocrinologue", api: "endocrinology" },
  "anesthesiste": { label: "Anesthésiste", api: "anesthesiology" },
  "rhumatologue": { label: "Rhumatologue", api: "rheumatology" },
  "medecin-physique": { label: "Médecine physique", api: "physical_medicine" },
  "nephrologue": { label: "Néphrologue", api: "nephrology" },
  "neurochirurgien": { label: "Neurochirurgien", api: "neurosurgery" },
};

const DoctorsByWilaya = () => {
  const { wilaya, specialty } = useParams();
  const navigate = useNavigate();
  const [doctors, setDoctors] = useState([]);
  const [loading, setLoading] = useState(true);

  const wilayaData = WILAYA_LABELS[wilaya];
  const wilayaLabel = wilayaData ? wilayaData.label : wilaya;
  const wilayaCode = wilayaData ? wilayaData.code : wilaya;
  const specialtyData = SPECIALTY_LABELS[specialty];
  const specialtyLabel = specialtyData ? specialtyData.label : specialty;
  const specialtyApi = specialtyData ? specialtyData.api : specialty;

  useEffect(() => {
    const fetchDoctors = async () => {
      try {
        const firstRes = await axios.get(`${API_URL}/api/doctors`, {
          params: { wilaya: wilayaCode, specialty: specialtyApi, limit: 1, page: 1 },
        });
        const total = firstRes.data.total || 0;
        // Correctif : le backend plafonne "limit" a 50 (voir Query(..., le=50)
        // dans routes/doctors.py). Envoyer le total brut (souvent > 50)
        // declenchait une erreur 422 avalee silencieusement par le .catch()
        // ci-dessous, affichant "Aucun medecin trouve" alors que des
        // medecins existaient bel et bien.
        const cappedLimit = Math.min(total, 50) || 50;
        const res = await axios.get(`${API_URL}/api/doctors`, {
          params: { wilaya: wilayaCode, specialty: specialtyApi, limit: cappedLimit, page: 1 },
        });
        setDoctors(res.data.doctors || []);
      } catch (err) {
        setDoctors([]);
      } finally {
        setLoading(false);
      }
    };
    fetchDoctors();
  }, [wilaya, specialty, wilayaCode, specialtyApi]);

  return (
    <>
      <Helmet>
        <title>{specialtyLabel}s à {wilayaLabel} | Tabbibak</title>
        <meta
          name="description"
          content={`Trouvez et prenez rendez-vous avec un ${specialtyLabel} à ${wilayaLabel}. Liste complète des ${specialtyLabel}s disponibles sur Tabbibak.dz`}
        />
        <link rel="canonical" href={`https://tabbibak.com/medecins/${wilaya}/${specialty}`} />
        <meta property="og:title" content={`${specialtyLabel}s à ${wilayaLabel} | Tabbibak`} />
        <meta
          property="og:description"
          content={`Trouvez et prenez rendez-vous avec un ${specialtyLabel} à ${wilayaLabel}. Liste complète des ${specialtyLabel}s disponibles sur Tabbibak.dz`}
        />
        <meta property="og:url" content={`https://tabbibak.com/medecins/${wilaya}/${specialty}`} />
      </Helmet>

      <div className="min-h-screen bg-[#F8FAFC]">
        <Navbar />
        <div className="max-w-4xl mx-auto px-4 py-8">
          <h1 className="text-2xl font-bold text-[#1A2B3C] mb-2">
            {specialtyLabel}s à {wilayaLabel}
          </h1>
          <p className="text-[#64748B] mb-6">
            {loading ? "Chargement..." : `${doctors.length} médecin(s) trouvé(s)`}
          </p>

          {loading ? (
            <div className="space-y-4">
              {[1, 2, 3].map((i) => (
                <div key={i} className="bg-white rounded-xl p-6 animate-pulse">
                  <div className="h-6 bg-gray-200 rounded w-1/3 mb-2" />
                  <div className="h-4 bg-gray-200 rounded w-1/4" />
                </div>
              ))}
            </div>
          ) : doctors.length === 0 ? (
            <div className="bg-white rounded-xl p-8 text-center text-[#64748B]">
              Aucun médecin trouvé pour cette recherche.
            </div>
          ) : (
            <div className="space-y-4">
              {doctors.map((doctor) => (
                <div
                  key={doctor.doctor_id}
                  className="bg-white rounded-xl border border-[#E2E8F0] p-6 flex items-center justify-between cursor-pointer hover:shadow-md transition-shadow"
                  onClick={() => navigate(`/doctor/${doctor.doctor_id}`)}
                >
                  <div className="flex items-center gap-4">
                    <div className="w-14 h-14 rounded-xl bg-[#E6F4FB] flex items-center justify-center text-[#0596DE] font-bold text-lg">
                      {doctor.name?.charAt(0).toUpperCase()}
                    </div>
                    <div>
                      <h2 className="font-semibold text-[#1A2B3C]">{doctor.name}</h2>
                      <p className="text-[#0596DE] text-sm">{doctor.specialty}</p>
                      <p className="text-[#64748B] text-sm">{doctor.address}</p>
                    </div>
                  </div>
                  <button
                    className="bg-[#0596DE] text-white px-4 py-2 rounded-lg text-sm hover:bg-[#047CBA] transition-colors"
                    onClick={(e) => { e.stopPropagation(); navigate(`/doctor/${doctor.doctor_id}`); }}
                  >
                    Prendre RDV
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default DoctorsByWilaya;